import React from 'react';
import { AnimatePresence } from 'framer-motion';
import Toast from './Toast';
import { ToastMessage } from '../../hooks/useToast';

interface ToastContainerProps {
  toasts: ToastMessage[];
  removeToast: (id: string) => void;
}

const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, removeToast }) => {
  return (
    <div className="pointer-events-none fixed left-3 right-3 top-[calc(0.75rem+env(safe-area-inset-top,0px))] z-[9999] flex flex-col items-stretch gap-2 sm:left-auto sm:right-4 sm:top-[calc(1rem+env(safe-area-inset-top,0px))] sm:w-auto sm:items-end">
      <AnimatePresence>
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            message={toast.message}
            type={toast.type}
            onClose={() => removeToast(toast.id)}
          />
        ))}
      </AnimatePresence>
    </div>
  );
};

export default ToastContainer;
